import { ajax, toast, formatAcuracyRound, loadjs } from '@platform/api';
import { ERROR_SCALE } from '../../utils';

// 这里是抄的以前的，看不懂
export function createUpdateAfterBatchChange({
    getStore,
    updateAndAddRows,
}) {
    async function updateAfterBatchChange(param) {
        let {
            areaCode,
            column,
            indexs,
            queryValue,
            changedrows,
            pasteData,
            queryCondition: customQueryCondition,
            isManyCondition,
            extraAjaxParam = {},
            values,
        } = param;

        let rowKey = 'rowid',
            pageScope = this,
            store = getStore.call(this, areaCode),
            rows = store.getRows(),
            pks = Array.isArray(values) ? values : [];

        let pasteToast = (queryValue, rows, referFail) => {

            if (!store?.pasteInfo || !rows?.length) { return; }
            let { success, pasteFailToast = [], rowKey, columnInfo, maxLength, min, max } = store.pasteInfo || {},
                locale = store.getLocale();
            // 清空记录
            store.pasteInfo = undefined;
            if (!queryValue.length) { return; } //YBP-SCM-BUG-3328
            if (!referFail) {
                if (pasteFailToast && queryValue.length !== rows.length) {
                    pasteFailToast = pasteFailToast.filter(({ diff }) => diff < queryValue.length);
                    if (!pasteFailToast.length) { // 把不能粘贴的行剔除后没有错误了
                        success = true;
                    }
                }
                let pasteSuccessData = rows.filter(row => { return row.newvalue?.value !== ''; });
                pasteData = pasteData.filter(data => { return data !== ''; });
                queryValue.forEach(row => {
                    if (row.pasteErrorMsg) { //领域的提示
                        let isSameRowToast = pasteFailToast.some(({ diff, type }) => {
                            if (type !== "customer") {
                                let rowIndex = store.getRowData(rowKey).viewIndex + diff;
                                if (rowIndex === row.viewIndex) { //领域提示和平台提示都提示了某一行
                                    return true;
                                }
                            }

                        });
                        if (!isSameRowToast) {
                            pasteFailToast.push({
                                diff: row.viewIndex + 1,
                                type: 'customer',
                                msg: row.pasteErrorMsg,
                            });
                        }
                    }
                });
                if (pasteFailToast.length) { //格式问题， number、日期组件等格式校验
                    toast({
                        color: 'danger',
                        mark: 'paste-fail-toast',
                        usePunctuation: false,
                        // 共粘贴${1}条。成功${2}条，失败${3}条：
                        title: (locale['table0045'] || '')
                            .replace('${1}', queryValue.length)
                            .replace('${2}', Math.max(queryValue.length - pasteFailToast.length, 0))
                            .replace('${3}', Math.min(queryValue.length, pasteFailToast.length))
                            .concat('\n'),
                        content: pasteFailToast.map(({ diff, type, msg }, index) => {
                            if (type === 'length') {
                                // 第${1}条：${2}，最大录入长度为${3}；
                                return (locale[index === pasteFailToast.length - 1 ? 'table0047' : 'table0046'] || '')
                                    .replace('${1}', store.getRowData(rowKey).viewIndex + diff + 1)
                                    .replace('${2}', columnInfo.label)
                                    .replace('${3}', maxLength)
                                    .concat('\n');
                            } else if (type === 'range') {
                                if (typeof min === 'undefined') { min = Number.MIN_VALUE; }
                                if (typeof max === 'undefined') { max = Number.MAX_VALUE; }
                                // 第${1}条：${2}，输入值必须介于[${3},${4}]；
                                return (locale[index === pasteFailToast.length - 1 ? 'table0052' : 'table0051'] || '')
                                    .replace('${1}', store.getRowData(rowKey).viewIndex + diff + 1)
                                    .replace('${2}', columnInfo.label)
                                    .replace('${3}', min)
                                    .replace('${4}', max)
                                    .concat('\n');
                            } else if (type === "customer") { //领域的提示
                                // 第${1}条：${2}: ${3}，
                                return (locale['table_customer_toast']
                                    .replace('${1}', diff)
                                    .replace('${2}', column.label)
                                    .replace('${3}', msg)
                                    .concat('\n')
                                );
                            }
                            else {
                                // 第${1}条：${2}，格式错误；
                                return (locale[index === pasteFailToast.length - 1 ? 'table0049' : 'table0048'] || '')
                                    .replace('${1}', store.getRowData(rowKey).viewIndex + diff + 1)
                                    .replace('${2}', columnInfo.label)
                                    .concat('\n');
                            }
                        }),
                    });
                } else if (pasteSuccessData.length !== pasteData.length) { //参照不合法
                    toast({
                        content: `${locale?.['table_paste_fail']}` /*粘贴失败,存在不合法的粘贴值*/,
                        usePunctuation: false,
                        color: 'danger',
                    });
                } else if (success) {
                    toast({
                        content: `${locale?.['table0050']}` /*粘贴成功*/,
                        usePunctuation: false,
                    });
                }
            }
            if (document.querySelector('.table-next-body-inner-wrapper').contains(document.activeElement)) {
                document.activeElement?.blur();
            }
        };

        // 处理一遍indexs
        if (queryValue?.length) {
            let newIndexes = [];
            let lastRowDataIndex = 0;
            queryValue.forEach(row => {
                if (!row) {
                    return;
                }
                // 如果领域返回的数字类型精度不正确，做一次四舍五入
                let scale,
                    rowKey = row.rowid || row.rowId || row.key,
                    colKey = column.attrcode,
                    rawRow = store.getRowData(rowKey);
                scale = getDefaultScale(row.values[colKey]?.scale, rawRow?.values?.[colKey]?.scale, column?.scale);

                if (column.itemtype === 'number') {
                    row.values[colKey].value = formatAcuracyRound(row.values[colKey].value, scale, true);
                    row.values[colKey].scale = scale;
                }
                lastRowDataIndex = rawRow?.dataIndex ?? lastRowDataIndex + 1;
                newIndexes.push(lastRowDataIndex);
            });
            indexs = newIndexes;
        }

        if (changedrows?.length) {
            changedrows.forEach(row => {
                let scale,
                    rowKey = row.rowid || row.rowId || row.key,
                    colKey = column.attrcode,
                    rawRow = store.getRowData(rowKey);

                scale = getDefaultScale(row.oldvalue?.scale, rawRow?.values?.[colKey]?.scale, column?.scale);

                if (column.itemtype === 'number') {
                    row.newvalue.value = formatAcuracyRound(row.newvalue.value, scale, true);
                    row.newvalue.scale = scale;
                }
            });
        }

        let {
            attrcode,
            itemtype,
            editAfterFlag,
            refcode,
            fieldDisplayed = "refname",
            fieldValued = "refpk",
            queryCondition,
            pk_defdoclist, dataPowerOperationCode, isDataPowerEnable,
            loadSelectedData, //参照需要的属性
            onlyLeafCanSelect,
        } = column;

        if (itemtype === "refer") {
            if (/.js/.test(refcode)) {
                refcode = refcode.replace(".js", "");
            }
            if (!refcode || !window[refcode]) {
                await new Promise(resolve => {
                    loadjs(formatRefCode(refcode), () => resolve());
                });
                // console.error(`window中没有refcode: ${refcode}`);
            }

            let refer = window[refcode].default();
            let url = refer.props.queryGridUrl || refer.props.queryTreeUrl;
            let referProps = refer.props;
            let { checkStrictly } = referProps;
            if (checkStrictly === false) {
                //摘要走这里
                return new Promise(resolve => {
                    console.error('非严格参照，比如摘要');
                    let newChangedRows = [];
                    queryValue.forEach((row, i) => {
                        let initVal = changedrows[i].oldvalue;

                        //摘要这样的参照 value和display都一样
                        let isRefpk = initVal && typeof initVal === 'object' ? initVal.value : initVal;
                        let theValue = {
                            display: row.values[attrcode].value,
                            value: row.values[attrcode].value,
                        };
                        row.values[attrcode].display = row.values[attrcode].value;
                        newChangedRows.push({
                            rowid: row[rowKey],
                            newvalue: { value: theValue.value || "" },
                            oldvalue: { value: isRefpk || "" },
                        });
                    });
                    // 先清空值，再设值，否则参照不会更新-NCC-234400
                    queryValue.forEach(row => {
                        let rowKey = row.key || row.rowId || row.rowid;
                        let oldRow = store.getRowData(rowKey);
                        if (oldRow) {
                            store.setCellValue(rowKey, attrcode, { value: {} });
                        }
                    });
                    updateAndAddRows.call(pageScope, { rows: queryValue, tableId: areaCode }); //给表格赋值
                    // document.activeElement.blur();
                    pasteToast(queryValue, newChangedRows);
                    resolve({
                        props: pageScope,
                        indexs,
                        key: attrcode,
                        changedrows: newChangedRows,
                    });
                });
            }
            let TreeRefActionExt =
                "nccloud.web.uap.refer.BatchQueryByNameSqlBuilder";
            let GridRefActionExt =
                "nccloud.web.uap.refer.BatchQueryByNameSqlBuilder";

            // 模板上会返回下面几个属性
            let extraCondition = {};
            pk_defdoclist !== undefined && (extraCondition.pk_defdoclist = pk_defdoclist);
            dataPowerOperationCode !== undefined && (extraCondition.DataPowerOperationCode = dataPowerOperationCode);
            isDataPowerEnable !== undefined && (extraCondition.isDataPowerEnable = isDataPowerEnable);
            loadSelectedData && (extraCondition.loadSelectedData = true);

            let referFilter;
            let otherParams = { queryValue, attrcode, fieldValued, fieldDisplayed, indexs, changedrows };
            if (isManyCondition || column.refcondition) {
                let mergeAjaxData = [];
                queryValue.forEach((row, index) => {
                    let ajaxData = [row.values[attrcode].value];
                    let con = row.queryCondition;
                    let datajson = getExcelReferAjaxData({ ajaxData, refer, con, queryCondition, TreeRefActionExt, GridRefActionExt, extraCondition, extraAjaxParam, pks, onlyLeafCanSelect, column, row, pageScope, areaCode });
                    datajson.fieldDisplayed = fieldDisplayed; //告诉后端传的是编码refcode、名称refname、编码名称refcode/refname
                    let data = {
                        rqUrl: url,
                        rqJson: JSON.stringify(datajson),
                        rqCode: String(index),
                    };
                    mergeAjaxData.push(data);
                });
                let urlPaths = (String(url)).split('/');
                let forwardRule = '';
                urlPaths.forEach((item, i) => {
                    if (item === 'nccloud') {
                        forwardRule = urlPaths[i + 1];
                    }
                });
                referFilter = sendExcelReferMergeAjax(mergeAjaxData, otherParams, forwardRule);
            } else {
                let ajaxData = pasteData;
                let con = customQueryCondition;
                let data = getExcelReferAjaxData({ ajaxData, refer, con, queryCondition, TreeRefActionExt, GridRefActionExt, extraCondition, extraAjaxParam, pks, onlyLeafCanSelect, column, pageScope, areaCode });
                referFilter = sendExcelReferNomalAjax(data, url, otherParams);
            }

            return referFilter.then(res => {
                let changedrows = res.changedrows;
                let finalValues = res.finalValues;
                let referDatas = res.referDatas;
                let indexs = res.indexs;
                // 先清空值，再设值，否则参照不会更新-NCC-234400
                queryValue.forEach(row => {
                    let rowKey = row.key || row.rowId || row.rowid;
                    let oldRow = store.getRowData(rowKey);
                    if (oldRow) {
                        store.setCellValue(rowKey, attrcode, { value: {} });
                    }
                });

                if (editAfterFlag) {
                    pageScope.handleRelationItems({
                        type: "table",
                        areaCode: areaCode,
                        key: attrcode,
                        changedrows,
                        rows: finalValues,
                        column,
                    });
                } else {
                    //参照"单位"字段批量下拉时，finalValues有queryCondition字段,但表格rows信息不应存储这个字段，影响性能。应领域要求删掉。
                    finalValues.forEach(row => delete row.queryCondition);
                    updateAndAddRows.call(pageScope, { rows: finalValues, tableId: areaCode }); //给表格赋值
                }
                // document.activeElement.blur();
                pasteToast(queryValue, changedrows, res.referFail);
                return {
                    props: pageScope,
                    key: attrcode,
                    changedrows,
                    referDatas,
                    indexs,
                };
            });
        } else {
            //除了參照以外类型的编辑关联项的处理
            if (editAfterFlag) {
                return new Promise(resolve => {
                    // // 先清空值，再设值，否则参照不会更新-NCC-234400
                    // queryValue.forEach(row => {
                    //     let rowKey = row.key || row.rowId || row.rowid;
                    //     let oldRow = store.getRowData(rowKey);
                    //     if (oldRow) {
                    //         store.setCellValue(rowKey, attrcode, { value: {} });
                    //     }
                    // });
                    pageScope.handleRelationItems({
                        type: "table",
                        areaCode: areaCode,
                        key: attrcode,
                        changedrows,
                        isMul: true,
                        rows: queryValue,
                        column,
                    });
                    // document.activeElement.blur();
                    pasteToast(queryValue, changedrows);
                    resolve({
                        props: pageScope,
                        changedrows,
                        key: attrcode,
                        indexs,
                    });
                });
            } else {
                return new Promise(resolve => {
                    // 先清空值，再设值，否则参照不会更新-NCC-234400
                    // queryValue.forEach(row => {
                    //     let rowKey = row.key || row.rowId || row.rowid;
                    //     let oldRow = store.getRowData(rowKey);
                    //     if (oldRow) {
                    //         store.setCellValue(rowKey, attrcode, { value: {} });
                    //     }
                    // });
                    updateAndAddRows.call(pageScope, { rows: queryValue, tableId: areaCode }); //给表格赋值
                    // 把失焦事件从excel/index.js listenCrtlV方法复制粘贴挪到了这里
                    // 解决日期组件提前失焦导致第一行数据不能粘贴成功的问题
                    // document.activeElement.blur();
                    pasteToast(queryValue, changedrows);
                    resolve({
                        props: pageScope,
                        changedrows,
                        key: attrcode,
                        indexs,
                    });
                });
            }
        }

        // return new Promise(resolve => {
        //     let { editAfterFlag, attrcode } = column;

        //     if (editAfterFlag) {
        //         this.handleRelationItems({
        //             type: "table",
        //             areaCode: areaCode,
        //             key: attrcode,
        //             changedrows,
        //             isMul: true,
        //             rows: queryValue,
        //         });
        //     }
        //     resolve({
        //         changedrows,
        //         indexs,
        //         key: attrcode,
        //         props: this,
        //     });
        // });
    }

    function getExcelReferAjaxData({ ajaxData, refer, con, queryCondition, TreeRefActionExt, GridRefActionExt, extraCondition, extraAjaxParam, pks, onlyLeafCanSelect, column, row, pageScope, areaCode: moduleId }) {
        let query = {};
        if (typeof queryCondition === 'function') {
            query = Object.assign(
                {},
                queryCondition(refer.props),
                con,
            ); //先是组件的模板上的condition，被业务组注册进来的condition覆盖
        } else if (queryCondition && typeof queryCondition === 'object') {
            query = Object.assign({}, queryCondition, con);
        } else if (queryCondition === undefined) {
            query = Object.assign({}, con);
        }
        if (typeof query.TreeRefActionExt === 'string') {
            if (query.TreeRefActionExt) {
                TreeRefActionExt = query.TreeRefActionExt + "," + TreeRefActionExt;
            }
        }
        if (typeof query.GridRefActionExt === 'string') {
            if (query.GridRefActionExt) {
                GridRefActionExt = query.GridRefActionExt + "," + GridRefActionExt;
            }
        }
        delete query.TreeRefActionExt;
        delete query.GridRefActionExt;

        let final = {
            pageInfo: {
                pageSize: 50,
                pageIndex: -1,
            },
            keyword: "",
            pid: "",
            defineItems: [],
            queryCondition: {
                batchQueryByName: JSON.stringify({ names: ajaxData }),
                batchQueryByPk: JSON.stringify({ pks }),
                TreeRefActionExt,
                GridRefActionExt,
                onlyLeafCanSelect,
                ...extraCondition,
                ...query,
            },
            ...extraAjaxParam,
        };

        let { refcondition: refCondition } = column;

        if (refCondition) {
            refCondition = JSON.parse(refCondition);
        }

        if(Array.isArray(refCondition)){
            final.refRelyCondition = refCondition
                .filter(condition => condition?.key && condition?.value)
                .reduce((refRelyCondition, condition) => {
                    let { key, value, nofilter, valueType, areacode } = condition;
                    
                    if (valueType !== 'const') {
                        let cellValue = row.values[value];
                        if (areacode !== moduleId) {
                            let formMainId = areacode,
                                meta = pageScope.state.meta;

                            meta?.formrelation && Object.keys(meta.formrelation).some(key => {
                                if (meta.formrelation[key]?.includes(areacode) && meta[key].moduletype === 'form') {
                                    formMainId = key;
                                    return true;
                                }
                            });
                            meta?.formassociatedrelation && Object.keys(meta.formassociatedrelation).some(key => {
                                if (meta.formassociatedrelation[key]?.['formtabs']?.includes(formMainId) && meta[key].moduletype === 'form') {
                                    formMainId = key;
                                    return true;
                                }
                            });
                            cellValue = pageScope.form.getFormItemsValue(formMainId, value);
                        }

                        value = cellValue?.value;
                    }

                    final.queryCondition[key] = value;

                    if (!nofilter) {
                        refRelyCondition[key] = value;
                    }

                    return refRelyCondition;
                }, {});
        }

        return final;
    }

    //多个querycondition的参照过滤
    function sendExcelReferMergeAjax(reqData, otherParams, forwardRule = '') {
        return new Promise((resolve, reject) => {
            ajax({
                url: `/nccloud/${forwardRule ? (forwardRule + '/') : ''}platform/pub/mergerequest.do`,
                data: reqData,
                success: res => {
                    let param = { res, ...otherParams };
                    let data = excelReferMergeAjaxSuccess(param);
                    resolve(data);
                },
                error: error => {
                    console.error(error);
                    reject(error);
                },
            });
        });
    }

    //一个querycondition的参照过滤
    function sendExcelReferNomalAjax(ajaxdata, url, otherParams) {
        return new Promise((resolve, reject) => {
            ajax({
                url,
                async: false,
                data: { ...ajaxdata },
                success: res => {
                    let param = { res, ...otherParams };
                    let data = excelReferNomalAjaxSuccess(param);
                    resolve(data);
                },
                error: error => {
                    console.error(error);
                    reject(error);
                },
            });
        });
    }

    function excelReferMergeAjaxSuccess(param) {
        let { res, queryValue, attrcode, fieldValued, fieldDisplayed, indexs, changedrows } = param;
        let rowKey = 'rowid';
        if (res.data) {
            let newChangedRows = [];
            let ajaxValues = [];
            let referDatas = [];
            Object.keys(res.data).forEach(index => {
                let resValue = res.data[index];
                let row = queryValue[index];
                if (resValue.rows.length) {
                    let cell = row.values[attrcode].value;
                    let finalVal = "";
                    let finalDis = "";
                    let referData;
                    let flag = false;
                    for (let i = 0; i < resValue.rows.length; i++) {
                        let item = resValue.rows[i];
                        item['refcode/refname'] = `${item.refcode}/${item.refname}`;
                        //助记码
                        let rememberCode = item.values && item.values.materialmnecode && item.values.materialmnecode.value;
                        if (cell?.toLowerCase() == item['refcode']?.toLowerCase() || cell?.toLowerCase() == item['refname']?.toLowerCase() || cell?.toLowerCase() == rememberCode?.toLowerCase() || cell?.toLowerCase() == item[fieldDisplayed]?.toLowerCase() || Object.values(item.values).some(e => e?.value?.toLowerCase() === cell?.toLowerCase())) {
                            finalVal += item[fieldValued];
                            finalDis += item[fieldDisplayed];
                            referData = item;
                            flag = true;
                            break;
                        }
                    }
                    let initVal = changedrows[index].oldvalue;
                    let isRefpk = initVal && typeof initVal === 'object' ? initVal.value : initVal;
                    if (flag) {
                        let theValue = {
                            display: finalDis,
                            value: finalVal,
                        };
                        newChangedRows.push({
                            rowid: row[rowKey],
                            newvalue: { value: theValue.value || "" },
                            oldvalue: { value: isRefpk || "" },
                        });
                        //把最终值赋给queryvalue
                        row.values[attrcode].value = finalVal;
                        row.values[attrcode].display = finalDis;
                        ajaxValues.push(row);
                        referData && referDatas.push(referData);
                    } else {
                        let initVal = changedrows[index].oldvalue;
                        let isRefpk = initVal && typeof initVal === 'object' ? initVal.value : initVal;
                        newChangedRows.push({
                            rowid: row[rowKey],
                            newvalue: { value: "" },
                            oldvalue: { value: isRefpk || "" },
                        });
                        row.values[attrcode].value = "";
                        row.values[attrcode].display = "";
                        ajaxValues.push(row);
                    }
                } else {
                    let initVal = changedrows[index].oldvalue;
                    let isRefpk = initVal && typeof initVal === 'object' ? initVal.value : initVal;
                    newChangedRows.push({
                        rowid: row[rowKey],
                        newvalue: { value: "" },
                        oldvalue: { value: isRefpk || "" },
                    });
                    row.values[attrcode].value = "";
                    row.values[attrcode].display = "";
                    ajaxValues.push(row);
                }
            });
            return {
                indexs: indexs,
                finalValues: ajaxValues,
                changedrows: newChangedRows,
                referDatas: referDatas,
            };
        }
    }

    function excelReferNomalAjaxSuccess(param) {
        let { res, queryValue, attrcode, fieldValued, fieldDisplayed, indexs, changedrows } = param;
        let rowKey = 'rowid';
        if (res.data.rows.length) {

            let newChangedRows = [];
            let ajaxValues = [];
            let referDatas = [];

            queryValue.map((row, index) => {
                let cell = row.values[attrcode].value;
                let finalVal = "";
                let finalDis = "";
                let referData;
                let flag = false;
                for (let i = 0; i < res.data.rows.length; i++) {
                    let item = res.data.rows[i];
                    //助记码
                    let rememberCode = item.values && item.values.materialmnecode && item.values.materialmnecode.value;
                    if (cell?.toLowerCase() == item['refcode']?.toLowerCase() || cell?.toLowerCase() == item['refname']?.toLowerCase() || cell?.toLowerCase() == rememberCode?.toLowerCase() || cell?.toLowerCase() == item[fieldDisplayed]?.toLowerCase()) {
                        finalVal += item[fieldValued];
                        finalDis += item[fieldDisplayed];
                        referData = item;
                        flag = true;
                        break;
                    }
                }

                let initVal = changedrows[index].oldvalue;

                let isRefpk = initVal && typeof initVal === 'object' ? initVal.value : initVal;
                if (flag) {
                    let theValue = {
                        display: finalDis,
                        value: finalVal,
                    };
                    newChangedRows.push({
                        rowid: row[rowKey],
                        newvalue: { value: theValue.value || "" },
                        oldvalue: { value: isRefpk || "" },
                    });
                    //把最终值赋给queryvalue
                    row.values[attrcode].value = finalVal;
                    row.values[attrcode].display = finalDis;
                    ajaxValues.push(row);
                    referData && referDatas.push(referData);
                } else {
                    newChangedRows.push({
                        rowid: row[rowKey],
                        newvalue: { value: "" },
                        oldvalue: { value: isRefpk || "" },
                    });
                    row.values[attrcode].value = "";
                    row.values[attrcode].display = "";
                    ajaxValues.push(row);
                    console.error(
                        cell,
                        "参照过滤没有匹配数据",
                    );
                }
            });
            return {
                indexs,
                finalValues: ajaxValues,
                changedrows: newChangedRows,
                referDatas: referDatas,
                referFail: false,
            };
        } else {
            let newChangedRows = [];
            let ajaxValues = [];
            let referDatas = [];

            queryValue.map((row, index) => {
                let initVal = changedrows[index].oldvalue;
                let isRefpk = initVal && typeof initVal === 'object' ? initVal.value : initVal;
                newChangedRows.push({
                    rowid: row[rowKey],
                    newvalue: { value: "" },
                    oldvalue: { value: isRefpk || "" },
                });
                row.values[attrcode].value = "";
                row.values[attrcode].display = "";
                ajaxValues.push(row);
            });
            console.error(
                "参照过滤后返回的数组是空数组，没有查询到",
            );
            return {
                indexs,
                finalValues: ajaxValues,
                changedrows: newChangedRows,
                referDatas: referDatas,
                referFail: true,
            };
        }
    }

    function getDefaultScale(...scales) {
        return Math.max(Number(scales.find(e => !ERROR_SCALE.has(e)) ?? -1), 0);
    }

    return updateAfterBatchChange;
}

function formatRefCode(refcode) {
    var s = refcode.split('/'),
        refKey;
    refKey = s.slice(s.length - 5).join('/');
    refKey.includes('.js') && (refKey = refKey.substring(0, refKey.length - 3));
    return '../../../../' + refKey + '.js';
}